"use client"

const Error = () => {
  return (
    <div>에러가 발생했습니다.</div>
  )
}

export default Error